export const AuthConstant = {
    GET_TOKEN: 'GET_TOKEN',

    CLEAR_TOKEN:'CLEAR_TOKEN',

    INVALID_TOKEN:'INVALID_TOKEN',
    AUTH_ERROR:'AUTH_ERROR'
}